var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{class:`${_vm.baseClass}`},[(_vm.$slots.header)?_c('header',{class:`${_vm.baseClass}__header`},[_vm._t("header")],2):_vm._e(),(_vm.$slots.content)?_c('transition',{attrs:{"name":"epb-explain-search__content--animated"}},[_c('section',{class:`${_vm.baseClass}__content`},[_vm._t("content")],2)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }